module.exports = __webpack_public_path__ + "img/web-P4-2.9c3b35fa.png";